import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { Container, Card, Button, Table, Alert } from "react-bootstrap";
import axios from "axios";

import { checkCookie, getCookie } from "../../Utils/Utils";
import { AUCTION_API, AUCTION_BID_API, BID_VALUE_OPTIONS } from "../../../constants/Constants";
import Header from "../../Content/Header/Header";
import TokenMessage from "../../Content/TokenMessage/TokenMessage";

require("./AuctionDetails.scss");
class AuctionDetails extends Component {
  componentDidMount() {
    const { auctionId } = this.props.match.params;
    if (!checkCookie("emailId")) {
      this.setState({ redirect: true });
    }

    axios.get(AUCTION_API + "/" + getCookie("userId"))
      .then(response => {
        const auctions = response.data.auctions;
        const allItems = Object.values(auctions).flat();
        const auctionItem = allItems.find(a => a.auctionId === auctionId);
        if (auctionItem) {
          this.setState({ auctionItem });

          this.setState({auctionItem}, () => {
            axios
              .get(AUCTION_BID_API + "/" + auctionId)
              .then(response => {
                this.setState({ bidDetails: response.data });
              });
          })
        } else {
          this.setState({ redirect: true });
        }
    });
  }



  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      auctionItem: null,
      bidDetails: []
    };

    this.handleBid = this.handleBid.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
  }

  

  handleBid(e) {
    let auctionBid = {};
    auctionBid.bidValue = e;
    auctionBid.userId = getCookie("userId");
    auctionBid.auctionId = this.state.auctionItem.auctionId;

    axios
      .post(AUCTION_BID_API, auctionBid, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(
        response => {
          axios
            .get(AUCTION_BID_API + "/" + auctionBid.auctionId)
            .then(response => {
              this.setState({ bidDetails: response.data });
            });
        },
        error => {
          console.log(error);
        }
      );
  }

  handleRefresh(e) {
    axios
      .get(AUCTION_BID_API + "/" + this.state.auctionItem.auctionId)
      .then(response => {
        this.setState({ bidDetails: response.data });
      });
  }
  
  render() {
    if (this.state.redirect) {
      return <Redirect to="/auction" />;
    }
    const item = this.state.auctionItem;
    if(!item) {
      return (
        <Container className="auctions-details-page-container">
          <Header />
          <TokenMessage />
          <div style={{ textAlign: "center", marginTop: "2rem" }}>
            <h5>Loading auction details...</h5>
          </div>
        </Container>
      );
    }
    const bidDetails = this.state.bidDetails;
    return (
      <Container className="auctions-details-page-container">
        <Header />
        <TokenMessage/>
        <Container className="back-button-container">
          <Link
            to={{
              pathname: "/auction"
            }}
            onClick={() => {
              sessionStorage.setItem("cameFromDetails", "true");
            }}
          >
            <Button className="button back-button">
              Back to Auctions Page
            </Button>
          </Link>
          <Alert className="starting-bid" variant="primary">
            STARTING BID: {item.startingValue} TOKENS
          </Alert>
        </Container>
        <Container className="auction-item-container">
          <Card className="auction-item-card">
            <Card.Img className="auction-image" src={item.imageName} />
            <Card.Body>
              <Card.Title
                className="auction-title"
                style={{ fontSize: "1.75rem" }}
              >
                {item.auctionName}
              </Card.Title>
              <Card.Text className="auction-description">
                {item.description} <br/> <br/>
                {item.link && (
                            <a
                              href={item.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Product link →
                            </a>
                          )}
              </Card.Text>
            </Card.Body>
          </Card>
        </Container>
        <Container className="auction-main-container">
          {item.active ? (
            <Container className="auction-button-container">
              <div className="auction-bid-title">INCREASE BID BY</div>
              <div className="auction-bid-options">
              {Object.keys(BID_VALUE_OPTIONS).map(key => (
                        <Button key={key} className="auction-button" onClick={() => {
                          this.handleBid(BID_VALUE_OPTIONS[key]);
                        }}>
                          {BID_VALUE_OPTIONS[key]} tokens
                        </Button>
                      ))}
              </div>
            </Container>
          ) : (
            <Container className="auction-button-container">
              <div className="auction-bid-title">The Auction is closed!</div>
            </Container>
          )}

          <Container className="auction-value-container">
            <div className="auction-refresh">
              <Button
                className="auction-refresh-button"
                variant="primary"
                onClick={this.handleRefresh}
              >
                REFRESH
              </Button>
            </div>

            <Table className="auction-details" striped bordered hover>
              <thead>
                <tr>
                  <th style={{ width: "70%", textAlign: "left" }}>Name</th>
                  <th style={{ width: "20%" }}>Tokens Bid</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(bidDetails || []).map(key => (
                  <tr key={key}>
                    <td style={{ width: "70%", textAlign: "left" }}>
                      {bidDetails[key].name}
                    </td>
                    <td>{bidDetails[key].bidValue}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Container>
        </Container>
      </Container>
    );
  
  }
}

export default AuctionDetails;
